<template>
  <AisToggleRefinement
    v-slot="{ value, refine, canRefine }"
    :attribute="filter.attributePath"
    :on="filter.attributeValue"
    :label="filter.attributeValue || 'true'"
  >
    <div v-if="!canRefine" />
    <FilterToggle
      v-else
      :id="`${filter.urlParam}_${kebabCase(value.name)}`"
      :key="value.name"
      :value="value.name"
      :name="filter.urlParam"
      :label="getFilterOptionLabel(filter.label)"
      :checked="value.isRefined"
      :addition="value.count+''"
      @change="refine(value)"
    />
  </AisToggleRefinement>
</template>

<script setup lang="ts">
// @ts-ignore
import kebabCase from 'lodash.kebabcase'
import FilterToggle from '~/components/category/product-filters/FilterToggle.vue'
import type { ProductFilter } from '~/types/productFilter'
import { useProductFilter } from '~/composables/useProductFilter'

defineProps({
  filter: {
    type: Object as () => ProductFilter,
    required: true
  }
})
const { getFilterOptionLabel } = useProductFilter()
</script>
